module.exports = __webpack_public_path__ + "img/treejer.cfc85903.png";